import { useTranslation } from "react-i18next";

import { QUESTION_RESULT_STATUSES } from "models";
import { enumToDropdownOptions } from "utils/common";

import type { DropdownItemProps } from "components";

type FilterOption = { id: number; name: string };

type UseDealerQualityChecksFilterOptionsProps = {
  mechanics: FilterOption[] | null;
  qualityChecklists: FilterOption[] | null;
  qcOfficers: FilterOption[] | null;
  dealerLocations: FilterOption[] | null;
};

export const questionStatusLookup: { translationKey: string; defaultMessage: string; key: QUESTION_RESULT_STATUSES }[] = [
  { key: QUESTION_RESULT_STATUSES.OK, translationKey: "v8_ok", defaultMessage: "OK" },
  { key: QUESTION_RESULT_STATUSES.OKWithRemarks, translationKey: "v8_ok_with_remarks", defaultMessage: "OK With Remarks" },
  { key: QUESTION_RESULT_STATUSES.Necessary, translationKey: "v8_necessary", defaultMessage: "Necessary" },
  { key: QUESTION_RESULT_STATUSES.Advice, translationKey: "v8_advised", defaultMessage: "Advised" },
  { key: QUESTION_RESULT_STATUSES.NVT, translationKey: "v8_not_worked_on", defaultMessage: "Not Worked On" }
];

const toDropdownOptions = (items: FilterOption[] | null): DropdownItemProps[] => items?.map(({ id, name }) => ({ key: id, value: id, text: name })) ?? [];

export const useDealerQualityChecksFilterOptions = ({ mechanics, qualityChecklists, qcOfficers, dealerLocations }: UseDealerQualityChecksFilterOptionsProps) => {
  const { t } = useTranslation();

  const mechanicsDropdownOptions = toDropdownOptions(mechanics);
  const locationsDropdownOptions = toDropdownOptions(dealerLocations);
  const qcOfficersDropdownOptions = toDropdownOptions(qcOfficers);
  const qcChecklistsDropdownOptions = toDropdownOptions(qualityChecklists);

  const qcStatusesDropdownOptions = enumToDropdownOptions({ enumObj: QUESTION_RESULT_STATUSES, t, keysToExclude: ["NoStatus", "FirstWithoutNoStatus"] });

  return { mechanicsDropdownOptions, locationsDropdownOptions, qcOfficersDropdownOptions, qcStatusesDropdownOptions, qcChecklistsDropdownOptions };
};
